<!-- MODAL -->
<div
  id="modal-footer-options"
  class="modal"
  [ngClass]="{visible: _showModal}"
>
  <div
    class="modal-dialog"
    role="document"
  >
    <div class="modal-content box">
      <button
        type="button"
        class="close"
        (click)="onCloseModal()"
      >
        <img
          src="assets/images/icons/cross-blue.svg"
          alt=""
        />
        <span class="sr-only">Cerrar ventana</span>
      </button>
      <div class="modal-body">
        <ng-container *ngTemplateOutlet="modal_content"></ng-container>
      </div>
    </div>
  </div>
</div>
